/** Deep links to Google Maps for "Open in Google Maps" actions. */

export function gmapsPlaceLink(
  lat: number | null,
  lng: number | null,
  query?: string,
): string {
  if (lat != null && lng != null) {
    return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`
  }
  const q = encodeURIComponent(query ?? '')
  return `https://www.google.com/maps/search/?api=1&query=${q}`
}

/** Multi-stop directions link from a list of [lat,lng] coordinates. */
export function gmapsRouteLink(points: Array<{ lat: number | null; lng: number | null }>): string {
  const coords = points.filter((p) => p.lat != null && p.lng != null)
  if (coords.length === 0) return 'https://www.google.com/maps'
  if (coords.length === 1) {
    return gmapsPlaceLink(coords[0].lat, coords[0].lng)
  }
  const destination = coords[coords.length - 1]
  const origin = coords[0]
  const waypoints = coords
    .slice(1, -1)
    .map((p) => `${p.lat},${p.lng}`)
    .join('|')
  const base = `https://www.google.com/maps/dir/?api=1&origin=${origin.lat},${origin.lng}&destination=${destination.lat},${destination.lng}`
  return waypoints ? `${base}&waypoints=${encodeURIComponent(waypoints)}` : base
}
